import { T } from '../strings'
import type { Theme } from '../theme'
import type { Screen } from '../game/types'

interface Props {
  screen: Screen
  theme: Theme
  onNavigate: (screen: Screen) => void
}

const TABS: Array<{ screen: Screen; icon: string; label: string }> = [
  { screen: 'home', icon: '🎮', label: T.navGame },
  { screen: 'friends', icon: '👋', label: T.navFriends },
  { screen: 'awards', icon: '🏆', label: T.navAwards },
  { screen: 'profile', icon: '🙂', label: T.navProfile },
]

export default function BottomNav({ screen, theme, onNavigate }: Props) {
  return (
    <nav className="nav">
      {TABS.map((tab) => {
        const active = tab.screen === screen
        return (
          <button
            key={tab.screen}
            type="button"
            className="nav__item"
            aria-current={active ? 'page' : undefined}
            onClick={() => onNavigate(tab.screen)}
            style={{ color: active ? theme.ink : theme.ink2, opacity: active ? 1 : 0.7 }}
          >
            <span style={{ fontSize: 19, filter: active ? 'none' : 'grayscale(.6)' }} aria-hidden>
              {tab.icon}
            </span>
            <span>{tab.label}</span>
          </button>
        )
      })}
    </nav>
  )
}
